"use client";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosArrowUp } from "react-icons/io";
import { cn } from "@/lib/cn";

interface accordionProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
}
const Accordion = ({ title, description }: accordionProps) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <motion.div className="px-6 border border-neutral-700 overflow-hidden rounded-xl bg-gradient-to-r from-neutral-900 to-neutral-900 bg-opacity-50 shadow-neutral-800 shadow">
      <motion.div
        className="py-6 w-full flex items-center justify-between cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <h4 className="underline">{title}</h4>
        <motion.div
          className={cn(expanded ? "" : "rotate-180", "transition-transform")}
        >
          <IoIosArrowUp size={20} />
        </motion.div>
      </motion.div>

      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
          >
            <p className="overflow-hidden py-4 pb-8 leading-[150%]">
              {description}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default Accordion;
